export class FetchLoggedOutError extends Error {}
